export const formatDate = (date: string): string => {
  // (Tanguy S) 22/06/2022
  // Wordpress dates are missing the ending Z to indicate it's UTC (ISO 8601)
  if (date.charAt(date.length - 1) !== "Z") {
    date = date + "Z";
  }

  return new Date(Date.parse(date)).toLocaleString();
};
